<ion-content>
  <app-global-page-header [title]="title | translate">
    <div slot="end">
      <ion-button
        color="medium"
        fill="clear"
        shape="round"
        (click)="dismissModal()"
      >
        <i class="fa-solid fa-times"></i>
      </ion-button>
    </div>
  </app-global-page-header>

  <div class="p-4">
    <div class="row">
      @if (step === 0) {
        <div class="col-12">
          <div>
            <img
              style="width: 100%; object-fit: contain; height: 200px"
              src="/assets/ecosystem/images/products/P00032/P00032-debit-0.png"
            />
          </div>

          <div class="text-center mb-4">
            <div
              class="d-inline-block mx-1 bullet"
              [class.bullet-select]="true"
            >
              <div class="row h-100">
                <div class="col p-0 text-center">1</div>
              </div>
            </div>

            <div
              class="d-inline-block mx-1 bullet"
              [class.bullet-select]="false"
            >
              <div class="row h-100">
                <div class="col p-0 text-center">2</div>
              </div>
            </div>
          </div>

          <div class="text-center mt-2">
            {{ 'P00032.installation.modal.page0.desc' | translate }}
          </div>
        </div>
      } @else if (step === 1) {
        <div class="col-12">
          <div>
            <img
              style="width: 100%; object-fit: contain; height: 200px"
              src="/assets/ecosystem/images/products/P00032/P00032-debit-1.png"
            />
          </div>

          <div class="text-center mb-4">
            <div
              class="d-inline-block mx-1 bullet"
              [class.bullet-select]="true"
            >
              <div class="row h-100">
                <div class="col p-0 text-center">1</div>
              </div>
            </div>

            <div
              class="d-inline-block mx-1 bullet"
              [class.bullet-select]="true"
            >
              <div class="row h-100">
                <div class="col p-0 text-center">2</div>
              </div>
            </div>
          </div>

          <div class="text-center mt-2">
            {{ 'P00032.installation.modal.page1.desc' | translate }}
          </div>
        </div>
      } @else if (step === 2) {
        <div class="col-12">
          <div>
            <img
              style="width: 100%; object-fit: contain; height: 200px"
              src="/assets/ecosystem/images/products/P00032/P00032-debit-2.png"
            />
          </div>

          <div class="text-center mb-4">
            <div
              class="d-inline-block mx-1 bullet"
              [class.bullet-select]="false"
            >
              <div class="row h-100">
                <div class="col p-0 text-center">1</div>
              </div>
            </div>

            <div
              class="d-inline-block mx-1 bullet"
              [class.bullet-select]="false"
            >
              <div class="row h-100">
                <div class="col p-0 text-center">2</div>
              </div>
            </div>
          </div>

          <div class="text-center mt-2">
            {{ 'P00032.installation.modal.page2.desc' | translate }}
          </div>
        </div>
      }
    </div>
  </div>
</ion-content>

<ion-footer class="p-3">
  @if (step === 0) {
    <div class="row">
      <div class="col text-center">
        <ion-button color="primary" (click)="setMemValue()">
          {{ 'generic.itsdone' | translate }}
        </ion-button>
      </div>
    </div>
  } @else if (step === 1) {
    <div class="row">
      <div class="col text-center">
        <ion-button color="primary" (click)="setMemValue2()">
          {{ 'generic.itsdone' | translate }}
        </ion-button>
      </div>
    </div>
  } @else if (step === 2) {
    <div class="row">
      <div class="col text-center">
        <ion-button color="primary" (click)="setStep(0)">
          {{ 'generic.jerecommence' | translate }}
        </ion-button>
      </div>
    </div>
  }
</ion-footer>
